import useExportFile from '../useExportFile';

export default function useExportStacks() {
  const { exportFile, isExporting, error } = useExportFile({
    endpoint: 'stacks/export-file',
    entityName: 'Stacks',
  });

  const exportStacks = async (): Promise<boolean> => {
    return exportFile();
  };

  return {
    exportStacks,
    isExporting,
    error,
  };
}
